module.exports = __webpack_public_path__ + "static/sunes-intervention_mtg_ahbg-736df956396cf2e9e1b67abb4196061a.webp";